import InfoIcon from '@material-ui/icons/Info';
import PropTypes from 'prop-types';
import React from 'react';

class Information extends React.Component {

    render() {

        const { text, dataTest, margin } = this.props;

        return (
            <div data-test={dataTest || "information-box"} style={{
                fontSize: 14,
                color: '#01579B',
                marginBottom: margin ? '12px' : '0px'
            }}>
                <InfoIcon style={{ verticalAlign: 'middle', transform: 'translateY(-1px)' }} />
                <span style={{ marginLeft: 6 }}>
                    {text}
                </span>
            </div >

        );
    }
}

Information.defaultProps = {
    margin: false
};

Information.propTypes = {
    margin: PropTypes.bool,
    text: PropTypes.string.isRequired,
    dataTest: PropTypes.string
};

export default Information;